<template>
  <div class="checkout-page">
    <div class="wrapper">
      <div class="form-widg">
        <div class="form-widg-in">
          <div style="display: contents;" id="widget-content"></div>
          <div class="footer-widget">
            <div class="copyright">
              The charge will appear on your bill as "{{ company?.projectName }}"<br />
              Owned and operated by "[COMPANY NAME]"<br />
              [COMPANY ADDRESS]<br />
              {{ company?.emailFrom }}<br />
              {{ company?.companyPhoneNumber }}
            </div>
          </div>
        </div>
      </div>

      <div id="thanksPopup" class="popup-container">
        <div class="popup">
          <div class="popup-wrapper">
            <svg
                id="closePopup"
                fill="#000000"
                width="16"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M0 14.545L1.455 16 8 9.455 14.545 16 16 14.545 9.455 8 16 1.455 14.545 0 8 6.545 1.455 0 0 1.455 6.545 8z"
                  fill-rule="evenodd"
              />
            </svg>
            <h2>Thank you for your interest!</h2>
            <p>
              We appreciate you taking the time to explore our demo. If you’d
              like to learn more about our services, feel free to visit our
              website or reach out to us directly.
            </p>
            <p>
              You can use the contact form on our site or message us right away
              on Telegram — <span>we're happy to help</span>!
            </p>
            <div class="popup-buttons">
              <a href="https://ecommasterweb.com">Visit Website</a>
              <a href="https://t.me/ecommasterweb" target="_blank">Contact via Telegram</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useCompanyStore} from "@/stores/company.js";
import {useRoute} from "vue-router";

const companyStore = useCompanyStore()
const route = useRoute()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})

const amount = computed(() => {
  return route.query.amount ? route.query.amount : 10
})

const allowed_currencies = [
  "EUR",
  "USD",
  "GBP",
  "JPY",
  "CAD",
  "AUD",
  "HKD",
  "NOK",
  "NZD",
  "DKK",
  "SGD",
  "ZAR",
  "INR",
  "PLN",
];

const widgetConfig = {
  merchant: {
    uuid: "123456",
    amount_disabled: false,
    allow_guest: true,
    company_name: "[COMPANY NAME]",
    frontend_settings: {},
  },
  payment_methods: [
    { payment_method: "card", name_for_client: "Cards", currencies: allowed_currencies },
  ],
};

onMounted(() => {
  document.addEventListener("showThanksPopup", () => {
    const popup = document.getElementById("thanksPopup");
    if (popup) {
      popup.style.display = "flex";

      const closeButton = document.getElementById("closePopup");
      closeButton.addEventListener("click", () => {
        popup.style.display = "none";
      });
    }
  });

  window.widgetConfig={
    "merchant": {
      "uuid":"123456",
      "is_disable_crypto":true,
      "wallet_acception_type":"ask_after_purchase",
      "amount_disabled":false,
      "is_system_widget":false,
      "allow_guest":true,
      "default_amount_eur": amount.value,
      "company_name":"[COMPANY NAME]",
      "min_eur_amount":null,
      "max_eur_amount":null,
      "min_crypto_amounts":{},
      "fee_fixed":"0.0",
      "min_btc_amount":null,
      "frontend_settings":{"custom_email_hint":"","fake_payment_methods":[],"payment_method_hints":[],"custom_html_before_title":"","terms_and_conditions_html":"","lock_email_edit_if_present":false,"auto_check_card_terms_checkbox":false,"terms_and_conditions_after_payment_method":""},
      "courses":{"usd_token":1.0,"eur_usd":"1.1426491813","usd_usd":1.0,"gbp_usd":"1.3510727649","jpy_usd":"0.006908181","cny_usd":"0.1391733423","cad_usd":"0.7308955029","aud_usd":"0.6522424449","hkd_usd":"0.1274103714","chf_usd":"1.2165992395","sek_usd":"0.1043245285","nok_usd":"0.0992067966","pln_usd":"0.26827428","myr_usd":"0.2360838679","nzd_usd":"0.6046520655","dkk_usd":"0.1532044294","czk_usd":"0.0461064953","sgd_usd":"0.7773240256","mxn_usd":"0.0524749734","thb_usd":"0.0306495628","zar_usd":"0.056472821","rub_usd":"0.0127418863","kzt_usd":"0.0019665865","uah_usd":"0.0233972859","uzs_usd":"0.0000782252","azn_usd":"0.5882122288","mdl_usd":"0.0580419132","inr_usd":"0.0116854223","vnd_usd":"0.0000384415","idr_usd":"0.0000614777","ars_usd":"0.0008440595","bob_usd":"0.144681175","clp_usd":"0.0010670112","cop_usd":"0.0002395934","crc_usd":"0.0019658159","dop_usd":"0.0169097777","gtq_usd":"0.130154112","pyg_usd":"0.0001252841","pen_usd":"0.2749811487","uyu_usd":"0.0240785688","aed_usd":"0.2722621748","bgn_usd":"0.5842178541","brl_usd":"0.1797037043","huf_usd":"0.0028485801","ils_usd":"0.2865076808","krw_usd":"0.0007315803","exchange_rate_id":1832438,"max_ttl":60,"ttl":"60"}},
    "payment_methods":[
      {"payment_method":"card","unified_name":"card","icon":"card","name_for_client":"Cards","currencies":allowed_currencies,},
      {"payment_method":"skrill","unified_name":"skrill","icon":"skrill","name_for_client":"Skrill","currencies":allowed_currencies,},
      {"payment_method":"eps","unified_name":"eps","icon":"eps","name_for_client":"EPS","currencies":allowed_currencies,},
      {"payment_method":"blik","unified_name":"blik","icon":"blik","name_for_client":"Blik","currencies":allowed_currencies,},
      {"payment_method":"sofort","unified_name":"sofort","icon":"sofort","name_for_client":"Sofort","currencies":allowed_currencies,},
      {"payment_method":"mbway","unified_name":"mbway","icon":"mbway","name_for_client":"Mbway","currencies":allowed_currencies,},
      {"payment_method":"paysafecard","unified_name":"paysafecard","icon":"paysafecard","name_for_client":"PaySafeCard","currencies":allowed_currencies,},
      {"payment_method":"neteller","unified_name":"neteller","icon":"neteller","name_for_client":"Neteller","currencies":allowed_currencies,},
      {"payment_method":"przelewy24","unified_name":"przelewy24","icon":"przelewy24","name_for_client":"Przelewy24","currencies":allowed_currencies,},
      {"payment_method":"multibanco","unified_name":"multibanco","icon":"multibanco","name_for_client":"Multibanco","currencies":allowed_currencies,},
      {"payment_method":"ideal","unified_name":"ideal","icon":"ideal","name_for_client":"iDEAL","currencies":allowed_currencies,},
      {"payment_method":"trustly","unified_name":"trustly","icon":"trustly","name_for_client":"Trustly","currencies":allowed_currencies,},
      {"payment_method":"payid","unified_name":"payid","icon":"payid","name_for_client":"PayID","currencies":allowed_currencies,},
    ],
    "locale":"en",
    "accept_header":"",
    "restricted_countries":[],
    "all_countries":[{"value":"AD","label":"Andorra"},{"value":"AE","label":"United Arab Emirates"},{"value":"AF","label":"Afghanistan"},{"value":"AG","label":"Antigua and Barbuda"},{"value":"AI","label":"Anguilla"},{"value":"AL","label":"Albania"},{"value":"AM","label":"Armenia"},{"value":"AO","label":"Angola"},{"value":"AQ","label":"Antarctica"},{"value":"AR","label":"Argentina"},{"value":"AS","label":"American Samoa"},{"value":"AT","label":"Austria"},{"value":"AU","label":"Australia"},{"value":"AW","label":"Aruba"},{"value":"AX","label":"Åland Islands"},{"value":"AZ","label":"Azerbaijan"},{"value":"BA","label":"Bosnia and Herzegovina"},{"value":"BB","label":"Barbados"},{"value":"BD","label":"Bangladesh"},{"value":"BE","label":"Belgium"},{"value":"BF","label":"Burkina Faso"},{"value":"BG","label":"Bulgaria"},{"value":"BH","label":"Bahrain"},{"value":"BI","label":"Burundi"},{"value":"BJ","label":"Benin"},{"value":"BL","label":"Saint Barthélemy"},{"value":"BM","label":"Bermuda"},{"value":"BN","label":"Brunei Darussalam"},{"value":"BO","label":"Bolivia"},{"value":"BQ","label":"Bonaire, Sint Eustatius and Saba"},{"value":"BR","label":"Brazil"},{"value":"BS","label":"Bahamas"},{"value":"BT","label":"Bhutan"},{"value":"BV","label":"Bouvet Island"},{"value":"BW","label":"Botswana"},{"value":"BY","label":"Belarus"},{"value":"BZ","label":"Belize"},{"value":"CA","label":"Canada"},{"value":"CC","label":"Cocos (Keeling) Islands"},{"value":"CD","label":"Congo, The Democratic Republic of the"},{"value":"CF","label":"Central African Republic"},{"value":"CG","label":"Congo"},{"value":"CH","label":"Switzerland"},{"value":"CI","label":"Côte d'Ivoire"},{"value":"CK","label":"Cook Islands"},{"value":"CL","label":"Chile"},{"value":"CM","label":"Cameroon"},{"value":"CN","label":"China"},{"value":"CO","label":"Colombia"},{"value":"CR","label":"Costa Rica"},{"value":"CU","label":"Cuba"},{"value":"CV","label":"Cabo Verde"},{"value":"CW","label":"Curaçao"},{"value":"CX","label":"Christmas Island"},{"value":"CY","label":"Cyprus"},{"value":"CZ","label":"Czechia"},{"value":"DE","label":"Germany"},{"value":"DJ","label":"Djibouti"},{"value":"DK","label":"Denmark"},{"value":"DM","label":"Dominica"},{"value":"DO","label":"Dominican Republic"},{"value":"DZ","label":"Algeria"},{"value":"EC","label":"Ecuador"},{"value":"EE","label":"Estonia"},{"value":"EG","label":"Egypt"},{"value":"EH","label":"Western Sahara"},{"value":"ER","label":"Eritrea"},{"value":"ES","label":"Spain"},{"value":"ET","label":"Ethiopia"},{"value":"FI","label":"Finland"},{"value":"FJ","label":"Fiji"},{"value":"FK","label":"Falkland Islands (Malvinas)"},{"value":"FM","label":"Micronesia, Federated States of"},{"value":"FO","label":"Faroe Islands"},{"value":"FR","label":"France"},{"value":"GA","label":"Gabon"},{"value":"GB","label":"United Kingdom"},{"value":"GD","label":"Grenada"},{"value":"GE","label":"Georgia"},{"value":"GF","label":"French Guiana"},{"value":"GG","label":"Guernsey"},{"value":"GH","label":"Ghana"},{"value":"GI","label":"Gibraltar"},{"value":"GL","label":"Greenland"},{"value":"GM","label":"Gambia"},{"value":"GN","label":"Guinea"},{"value":"GP","label":"Guadeloupe"},{"value":"GQ","label":"Equatorial Guinea"},{"value":"GR","label":"Greece"},{"value":"GS","label":"South Georgia and the South Sandwich Islands"},{"value":"GT","label":"Guatemala"},{"value":"GU","label":"Guam"},{"value":"GW","label":"Guinea-Bissau"},{"value":"GY","label":"Guyana"},{"value":"HK","label":"Hong Kong"},{"value":"HM","label":"Heard Island and McDonald Islands"},{"value":"HN","label":"Honduras"},{"value":"HR","label":"Croatia"},{"value":"HT","label":"Haiti"},{"value":"HU","label":"Hungary"},{"value":"ID","label":"Indonesia"},{"value":"IE","label":"Ireland"},{"value":"IL","label":"Israel"},{"value":"IM","label":"Isle of Man"},{"value":"IN","label":"India"},{"value":"IO","label":"British Indian Ocean Territory"},{"value":"IQ","label":"Iraq"},{"value":"IR","label":"Iran"},{"value":"IS","label":"Iceland"},{"value":"IT","label":"Italy"},{"value":"JE","label":"Jersey"},{"value":"JM","label":"Jamaica"},{"value":"JO","label":"Jordan"},{"value":"JP","label":"Japan"},{"value":"KE","label":"Kenya"},{"value":"KG","label":"Kyrgyzstan"},{"value":"KH","label":"Cambodia"},{"value":"KI","label":"Kiribati"},{"value":"KM","label":"Comoros"},{"value":"KN","label":"Saint Kitts and Nevis"},{"value":"KP","label":"North Korea"},{"value":"KR","label":"South Korea"},{"value":"KW","label":"Kuwait"},{"value":"KY","label":"Cayman Islands"},{"value":"KZ","label":"Kazakhstan"},{"value":"LA","label":"Lao People's Democratic Republic"},{"value":"LB","label":"Lebanon"},{"value":"LC","label":"Saint Lucia"},{"value":"LI","label":"Liechtenstein"},{"value":"LK","label":"Sri Lanka"},{"value":"LR","label":"Liberia"},{"value":"LS","label":"Lesotho"},{"value":"LT","label":"Lithuania"},{"value":"LU","label":"Luxembourg"},{"value":"LV","label":"Latvia"},{"value":"LY","label":"Libya"},{"value":"MA","label":"Morocco"},{"value":"MC","label":"Monaco"},{"value":"MD","label":"Moldova"},{"value":"ME","label":"Montenegro"},{"value":"MF","label":"Saint Martin (French part)"},{"value":"MG","label":"Madagascar"},{"value":"MH","label":"Marshall Islands"},{"value":"MK","label":"North Macedonia"},{"value":"ML","label":"Mali"},{"value":"MM","label":"Myanmar"},{"value":"MN","label":"Mongolia"},{"value":"MO","label":"Macao"},{"value":"MP","label":"Northern Mariana Islands"},{"value":"MQ","label":"Martinique"},{"value":"MR","label":"Mauritania"},{"value":"MS","label":"Montserrat"},{"value":"MT","label":"Malta"},{"value":"MU","label":"Mauritius"},{"value":"MV","label":"Maldives"},{"value":"MW","label":"Malawi"},{"value":"MX","label":"Mexico"},{"value":"MY","label":"Malaysia"},{"value":"MZ","label":"Mozambique"},{"value":"NA","label":"Namibia"},{"value":"NC","label":"New Caledonia"},{"value":"NE","label":"Niger"},{"value":"NF","label":"Norfolk Island"},{"value":"NG","label":"Nigeria"},{"value":"NI","label":"Nicaragua"},{"value":"NL","label":"Netherlands"},{"value":"NO","label":"Norway"},{"value":"NP","label":"Nepal"},{"value":"NR","label":"Nauru"},{"value":"NU","label":"Niue"},{"value":"NZ","label":"New Zealand"},{"value":"OM","label":"Oman"},{"value":"PA","label":"Panama"},{"value":"PE","label":"Peru"},{"value":"PF","label":"French Polynesia"},{"value":"PG","label":"Papua New Guinea"},{"value":"PH","label":"Philippines"},{"value":"PK","label":"Pakistan"},{"value":"PL","label":"Poland"},{"value":"PM","label":"Saint Pierre and Miquelon"},{"value":"PN","label":"Pitcairn"},{"value":"PR","label":"Puerto Rico"},{"value":"PS","label":"Palestine, State of"},{"value":"PT","label":"Portugal"},{"value":"PW","label":"Palau"},{"value":"PY","label":"Paraguay"},{"value":"QA","label":"Qatar"},{"value":"RE","label":"Réunion"},{"value":"RO","label":"Romania"},{"value":"RS","label":"Serbia"},{"value":"RU","label":"Russian Federation"},{"value":"RW","label":"Rwanda"},{"value":"SA","label":"Saudi Arabia"},{"value":"SB","label":"Solomon Islands"},{"value":"SC","label":"Seychelles"},{"value":"SD","label":"Sudan"},{"value":"SE","label":"Sweden"},{"value":"SG","label":"Singapore"},{"value":"SH","label":"Saint Helena, Ascension and Tristan da Cunha"},{"value":"SI","label":"Slovenia"},{"value":"SJ","label":"Svalbard and Jan Mayen"},{"value":"SK","label":"Slovakia"},{"value":"SL","label":"Sierra Leone"},{"value":"SM","label":"San Marino"},{"value":"SN","label":"Senegal"},{"value":"SO","label":"Somalia"},{"value":"SR","label":"Suriname"},{"value":"SS","label":"South Sudan"},{"value":"ST","label":"Sao Tome and Principe"},{"value":"SV","label":"El Salvador"},{"value":"SX","label":"Sint Maarten (Dutch part)"},{"value":"SY","label":"Syrian Arab Republic"},{"value":"SZ","label":"Eswatini"},{"value":"TC","label":"Turks and Caicos Islands"},{"value":"TD","label":"Chad"},{"value":"TF","label":"French Southern Territories"},{"value":"TG","label":"Togo"},{"value":"TH","label":"Thailand"},{"value":"TJ","label":"Tajikistan"},{"value":"TK","label":"Tokelau"},{"value":"TL","label":"Timor-Leste"},{"value":"TM","label":"Turkmenistan"},{"value":"TN","label":"Tunisia"},{"value":"TO","label":"Tonga"},{"value":"TR","label":"Türkiye"},{"value":"TT","label":"Trinidad and Tobago"},{"value":"TV","label":"Tuvalu"},{"value":"TW","label":"Taiwan"},{"value":"TZ","label":"Tanzania"},{"value":"UA","label":"Ukraine"},{"value":"UG","label":"Uganda"},{"value":"UM","label":"United States Minor Outlying Islands"},{"value":"US","label":"United States"},{"value":"UY","label":"Uruguay"},{"value":"UZ","label":"Uzbekistan"},{"value":"VA","label":"Holy See (Vatican City State)"},{"value":"VC","label":"Saint Vincent and the Grenadines"},{"value":"VE","label":"Venezuela"},{"value":"VG","label":"Virgin Islands, British"},{"value":"VI","label":"Virgin Islands, U.S."},{"value":"VN","label":"Vietnam"},{"value":"VU","label":"Vanuatu"},{"value":"WF","label":"Wallis and Futuna"},{"value":"WS","label":"Samoa"},{"value":"YE","label":"Yemen"},{"value":"YT","label":"Mayotte"},{"value":"ZA","label":"South Africa"},{"value":"ZM","label":"Zambia"},{"value":"ZW","label":"Zimbabwe"},{"value":"XK","label":"Kosovo"}],
    "allowed_currencies":allowed_currencies,
    "allowed_crypto_currencies":[],
    "params":{"amount":null,"currency":null,"crypto_currency":null},
    "user_options":{"email":null,"sign_in_allowed":false,"sign_up_allowed":false,},
  }

  const scripts = [
    "/packs/js/runtime.js",
    "/packs/js/widget.chunk1.js",
    "/packs/js/widget.chunk2.js",
    "/packs/js/widget.chunk3.js",
  ];

  scripts.forEach((src) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  });

  const styles = [
    "/packs/css/widget.css",
  ];

  styles.forEach((href) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  });

});
</script>

<style scoped>
.popup-container {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  justify-content: center;
  align-items: center;
}

.popup {
  position: relative;
  width: 50%;
  border-radius: 30px;
  background-color: #9588E8;
  padding: 7px;
}

.popup-wrapper {
  padding: 40px;
  border-radius: 30px;
  background-color: #FFF;
  text-align: center;
}

.popup svg {
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 25px;
}

.popup h2 {
  margin: 0 0 20px;
  color: #9588E8;
  font-size: 40px;
  font-weight: 500;
}

.popup p {
  margin: 0 0 10px;
  color: #111;
  font-size: 20px;
  font-weight: 500;
}

.popup p span {
  color: #9588E8;
}

.popup-buttons {
  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px
}

.popup a {
  cursor: pointer;
  transition: 0.2s;
  padding: 15px 40px;
  background-color: transparent;
  border-radius: 16px;
  border: 1px solid #9588E8;

  color: #000;
  font-size: 20px;
  text-decoration: none;
}
.popup a:hover {
  background-color: #9588E8;
  color: #fff;
}

@media (max-width: 1300px) {
  .popup {
    width: 70%;
  }
}

@media (max-width: 750px) {
  .popup {
    width: 90%;
  }

  .popup h2 {
    font-size: 28px;
  }

  .popup p {
    font-size: 14px;
  }

  .popup-buttons {
    gap: 30px;
  }

  .popup a {
    border-radius: 10px;
    padding: 10px 20px;
    font-size: 16px;
  }
}

@media (max-width: 450px) {
  .popup svg {
    top: 20px;
    right: 20px;
  }

  .popup h2 {
    font-size: 22px;
  }

  .popup p {
    font-size: 12px;
  }

  .popup-wrapper {
    padding: 20px;
  }

  .popup-buttons {
    flex-direction: column;
    gap: 15px;
  }
}
</style>